import module from '../module';
import Constants from '../../../utils/CommonConstants';

function SessionService(localForageService, timeoutService, rootScope) {

    let cartReference = undefined;
    let cartEmitTimeout = null;
    let stealthUserMode = null;

    return {

        getCartReference: async function () {
            return cartReference;
        },

        setCartReference: function (reference, notify = true) {
            cartReference = reference;
            if (!notify) {
                return;
            }

            if (cartEmitTimeout) {
                timeoutService.cancel(cartEmitTimeout);
            }

            cartEmitTimeout = timeoutService(() => {
                rootScope.$broadcast(Constants.RootEvents.CART_CHANGED);
                cartEmitTimeout = null;
            }, 200);
        },

        setSessionDetails: async function (details) {
            await localForageService.store(Constants.SessionStorage.USER_EMAIL, details.userEmail);
            await localForageService.store(Constants.SessionStorage.USER_NAME, details.userName);
            await localForageService.store(Constants.SessionStorage.USER_FIRST_NAME, details.firstName);
            await localForageService.store(Constants.SessionStorage.USER_LAST_NAME, details.lastName);
            await localForageService.store(Constants.SessionStorage.AUTH_TOKEN, details.authToken);
            await localForageService.store(Constants.SessionStorage.IS_INVITE, details.isInvite || false);
        },

        clearSessionDetails: async function () {
            await localForageService.remove(Constants.SessionStorage.USER_EMAIL);
            await localForageService.remove(Constants.SessionStorage.USER_NAME);
            await localForageService.remove(Constants.SessionStorage.USER_FIRST_NAME);
            await localForageService.remove(Constants.SessionStorage.USER_LAST_NAME);
            await localForageService.remove(Constants.SessionStorage.AUTH_TOKEN);
            await localForageService.remove(Constants.SessionStorage.IS_INVITE);
        },

        hasAuthToken: async function () {
            return await localForageService.exists(Constants.SessionStorage.AUTH_TOKEN);
        },

        getAuthToken: async function () {
            return await localForageService.retrieve(Constants.SessionStorage.AUTH_TOKEN);
        },

        clearAuthToken: async function() {
          return await localForageService.remove(Constants.SessionStorage.AUTH_TOKEN);
        },

        loggedIn: async function () {
            let email = await this.getUserEmail();
            return !!email;
        },

        isInvite: async function () {
            return await localForageService.retrieve(Constants.SessionStorage.IS_INVITE) == 'true';
        },

        getUserEmail: async function () {
            return await localForageService.retrieve(Constants.SessionStorage.USER_EMAIL);
        },

        getUserName: async function () {
            return await localForageService.retrieve(Constants.SessionStorage.USER_NAME);
        },

        getUserFirstName: async function () {
            return await localForageService.retrieve(Constants.SessionStorage.USER_FIRST_NAME);
        },

        getCachedUser: function () {
            return this._cachedUser;
        },

        setCachedUser: function (user) {
            this._cachedUser = user;
        },

        getStealthUserMode: function(){
            return stealthUserMode;
        },

        setStealthUserMode : function(value){
            stealthUserMode = value;
        }
    };
}

module.service('Session', ['LocalForageService', '$timeout', '$rootScope', SessionService]);



// WEBPACK FOOTER //
// ./src/modules/shared/services/SessionService.js